import { render, staticRenderFns } from "./Screen2.vue?vue&type=template&id=4e14ea1a&scoped=true&"
import script from "./Screen2.vue?vue&type=script&lang=js&"
export * from "./Screen2.vue?vue&type=script&lang=js&"
import style0 from "./Screen2.vue?vue&type=style&index=0&id=4e14ea1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e14ea1a",
  null
  
)

export default component.exports